import React, { useState, useEffect } from 'react'

import 'web_common/css/LimnTech.css'
import { db } from 'web_common/tsx/api/db/Api'
import { util, ReconciledNtripInfo } from 'web_common/tsx/api/db/Util'
import {
    CompanyAdminPrivilege,
    LifemarkUserModel,
    Truck,
    RtkService,
    NtripCredential
} from 'web_common/tsx/api/db/Models'
import ApiError from 'web_common/tsx/components/misc/ApiError'
import PermissionDenied from 'web_common/tsx/components/misc/PermissionDenied'
import Loading from 'web_common/tsx/components/misc/Loading'

import TruckAdminTable from 'components/trucks/list/TruckAdminTable'
import TruckUserTable from 'components/trucks/list/TruckUserTable'

interface TruckListProps {

}

const TruckList: React.FC<TruckListProps> = (props) => {
    const [apiError, setApiError] = useState<boolean>(false)
    const [lifemarkUser, setLifemarkUser] = useState<LifemarkUserModel|undefined>(undefined)
    const [trucks, setTrucks] = useState<Array<Truck>|undefined>(undefined)
    const [rtkServiceList, setRtkServiceList] = useState<Array<RtkService>|undefined>(undefined)
    const [ntripCredentialList, setNtripCredentialList] = useState<Array<NtripCredential>|undefined>(undefined)
    const [reconciledNtripInfo, setReconciledNtripInfo] = useState<Array<ReconciledNtripInfo>|undefined>(undefined)

    useEffect(() => {
        const onCurrentUser = (response: LifemarkUserModel|undefined) => {
            if(response === undefined)
            {
                setApiError(true)
            }
            else
            {
                setLifemarkUser(response)
            }
        }

        db.current_user(onCurrentUser)
    }, [])

    useEffect(() => {
        if(lifemarkUser !== undefined)
        {
            const onTrucks = (response: Array<Truck>|undefined) => {
                if(response === undefined)
                {
                    setApiError(true)
                }
                else
                {
                    setTrucks(response)
                }
            }

            db.truck_list(lifemarkUser.company, onTrucks)
        }
    }, [lifemarkUser])

    useEffect(() => {
        if(lifemarkUser !== undefined)
        {
            const onRtkService = (response: Array<RtkService>|undefined) => {
                if(response === undefined)
                {
                    setApiError(true)
                }
                else
                {
                    setRtkServiceList(response)
                }
            }

            db.list_rtk_services(lifemarkUser.company, onRtkService)
        }
    }, [lifemarkUser])

    useEffect(() => {
        if(lifemarkUser !== undefined)
        {
            const onNtripCredentials = (response: Array<NtripCredential>|undefined) => {
                if(response === undefined)
                {
                    setApiError(true)
                }
                else
                {
                    setNtripCredentialList(response)
                }
            }

            db.list_ntrip_credentials(
                lifemarkUser.company,
                undefined,
                onNtripCredentials)
        }
    }, [lifemarkUser])

    useEffect(() => {
        if(ntripCredentialList !== undefined &&
            rtkServiceList !== undefined &&
            trucks !== undefined)
        {
            let info: Array<ReconciledNtripInfo> = util.reconcileNtripInfo(
                trucks,
                rtkServiceList,
                ntripCredentialList)

            setReconciledNtripInfo(info)
        }
    }, [ntripCredentialList, rtkServiceList, trucks])

    if(apiError === true)
    {
        return <ApiError/>
    }
    else if(lifemarkUser !== undefined)
    {
        if(lifemarkUser.privilege === CompanyAdminPrivilege.NONE)
        {
            return (
                <PermissionDenied/>
            )
        }
        else if(reconciledNtripInfo !== undefined)
        {
            if(lifemarkUser.privilege === CompanyAdminPrivilege.ADMIN)
            {
                return (
                    <div className='limn-form-container'>
                        <h1 className='limn-header'> Trucks </h1>
                        <TruckAdminTable
                            reconciledNtripData={reconciledNtripInfo}
                        />
                    </div>
                )
            }
            else
            {
                return (
                    <div className='limn-form-container'>
                        <h1 className='limn-header'> Trucks </h1>
                        <TruckUserTable
                            reconciledNtripData={reconciledNtripInfo}
                        />
                    </div>
                )
            }
        }
        else
        {
           return (
                <div className='limn-form-container'>
                    <h1 className='limn-header'> Trucks </h1>
                    <Loading/>
                </div>
            )
        }
    }
    else
    {
        return (
            <div className='limn-form-container'>
                <h1 className='limn-header'> Trucks </h1>
                <Loading/>
            </div>
        )
    }
}

export default TruckList
